export enum CompanyTypeEnum {
  Fiat = 1,
  Crypto = 2,
}
